
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("9RyD0", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.05b3cb80.js.map
